import { Instagram, MessageCircle } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { IG_HANDLE, IG_LINK, WA_LINK } from "@/i18n";

export default function Footer() {
  const { t } = useStore();

  return (
    <footer id="kontak" data-testid="footer" className="border-t border-white/10 bg-black">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 px-4 py-14 sm:px-6 md:flex-row md:items-center lg:px-8">
        <div className="max-w-sm">
          <div className="flex items-center gap-3">
            <img
              src="/logo.jpg"
              alt="Nusua Betta logo"
              className="h-12 w-12 shrink-0 rounded-full object-cover ring-1 ring-white/20"
            />
            <span className="font-display text-lg font-bold tracking-[0.22em] text-white">
              NUSUA BETTA
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-mist">{t.footer.tagline}</p>
        </div>

        <div className="flex flex-col gap-3">
          <a
            data-testid="footer-whatsapp-link"
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-mist transition-colors hover:text-ember"
          >
            <MessageCircle size={14} className="text-ember" />
            WhatsApp — 0856 9277 7370
          </a>
          <a
            data-testid="footer-instagram-link"
            href={IG_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-mist transition-colors hover:text-ember"
          >
            <Instagram size={14} className="text-ember" />
            Instagram — @{IG_HANDLE}
          </a>
        </div>
      </div>
      <div className="border-t border-white/5">
        <p className="mx-auto max-w-7xl px-4 py-6 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600 sm:px-6 lg:px-8">
          {t.footer.rights}
        </p>
      </div>
    </footer>
  );
}
